import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import Sidenav from "../../components/Sidenav/Sidenav";

export default function Layout({ children }: PropsWithChildren) {
  return (
    <Stack direction="row">
      <Sidenav />
      {children}
    </Stack>
  );
}
